<template>
  <el-dialog :title="addFormItem.ids?'编辑模板信息':'保存为模板'"
    :visible.sync="$parent.dialogFormVisible"
    v-if="$parent.dialogFormVisible"
    style="width:70%;margin:0 auto">
    <el-form :model="form"
      label-width="120px"
      ref="ruleForm"
      :rules="rules">
      <el-form-item label="模板名称"
        prop="name">
        <el-input v-model="form.name"
          placeholder="请输入模板名称"
          maxlength="10"
          show-word-limit></el-input>
      </el-form-item>
      <el-form-item label="备注">
        <el-input type="textarea"
          rows="3"
          maxlength="50"
          show-word-limit
          placeholder="模板备注"
          v-model="form.desc"
          resize="none">
        </el-input>
      </el-form-item>
    </el-form>
    <div slot="footer"
      class="dialog-footer">
      <el-button @click="$parent.dialogFormVisible = false">取 消</el-button>
      <el-button type="primary"
        @click="submitForm('ruleForm')"
        :loading="btnLoading">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import api from "@/api";
export default {
  props: ["addFormItem"],
  data() {
    return {
      form: {
        name: "",
        desc: "",
      },
      rules: {
        name: [
          { required: true, message: "模板名称不能为空", trigger: "blur" },
          { whitespace: true, message: "模板名称不能为空", trigger: "blur" },
          {
            min: 1,
            max: 10,
            message: "请输入10个字以内",
            trigger: "blur",
          },
        ],
      },
      btnLoading: false,
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          return new Promise(async (resolve) => {
            let res = await api.formAddReport({
              x_type: this.addFormItem.xtype,
              x_data: this.addFormItem.xdata,
              y_data: JSON.stringify(this.addFormItem.ydata),
              key: this.addFormItem.key,
              name: this.form.name,
              searchText: this.form.desc,
              id: this.addFormItem.ids ? this.addFormItem.ids : "",
            });
            if (res && res.status == 200) {
              this.$message.success(
                this.addFormItem.ids ? "修改模板成功！" : "保存模板成功！"
              );
              this.btnLoading = false;
              this.$emit("handleRenewFun", this.form.name);
            }
            resolve();
          });
        } else {
          return false;
        }
      });
    },
  },
  created() {
    if (this.addFormItem.ids) {
      this.form.name = this.addFormItem.name;
      this.form.desc = this.addFormItem.searchText;
    }
  },
};
</script>

<style lang="scss" scoped>
</style>